/** @format */

import { CustomerActionTypes } from './customer.types';
import {
  addCustomerToSelection,
  removeCustomerFromSelection,
  updateCustomerMessageStatus,
} from './customer.utils';

const INITIAL_STATE = {
  customerData: [],
};

const customerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CustomerActionTypes.ADD_CUSTOMER:
      return {
        ...state,
        customerData: addCustomerToSelection(
          state.customerData,
          action.payload
        ),
      };

    case CustomerActionTypes.REMOVE_CUSTOMER:
      return {
        ...state,
        customerData: removeCustomerFromSelection(
          state.customerData,
          action.payload
        ),
      };

    case CustomerActionTypes.UPDATE_MESSAGE_DATA:
      return {
        ...state,
        customerData: updateCustomerMessageStatus(
          state.customerData,
          action.payload
        ),
      };

    case CustomerActionTypes.CLEAR_CUSTOMER_SELECTION:
    case CustomerActionTypes.CUSTOMER_DATA_RESET:
      return { ...INITIAL_STATE };

    default:
      return state;
  }
};

export default customerReducer;
